<!--
File: product-toolbar.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 24th February 2026 4:30:32 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<!-- <div style="width: 100px; height: 20px; background-color: red;"></div> -->
<div
  class="min-h-full max-h-full z-3 border-0 flex flex-column overflow-hidden no-select"
  *ngIf="filterLoaded"
  [ngClass]="!toolbarEnabled ? 'disabled' : ''"
>
  <app-product-toolbar-search
    [viewType]="viewType"
    (viewTypeChange)="changeViewType($event)"
    [idCatalog]="idCatalog"
    [idFascicle]="idFascicle"
    [filterOptions]="filterSettings"
    [viewedProducts]="filteredProducts.length"
    [filter]="filter"
    [(loading)]="loading"
    (sendFilterOptions)="getFilterOptions($event)"
    [sortableFields]="sortableFields"
    (showHistory)="showHistory.emit()"
  ></app-product-toolbar-search>

  <div
    class="flex-grow-1 flex-shrink-1 flex flex-column overflow-hidden"
    pDroppable
    (onDrop)="drop($event)"
    (dragenter)="OnDragEnter()"
    (dragleave)="OnDragLeave()"
    [ngClass]="{ 'hover-border': isDragging }"
  >
    <div class="flex-shrink-1 flex-grow-1 overflow-y-auto" #productDataList>
      <ng-container [ngSwitch]="viewType">
        <ng-container *ngSwitchCase="'list'">
          <app-product-list
            class=""
            [items]="filteredProducts"
          ></app-product-list>
        </ng-container>
        <ng-container *ngSwitchCase="'grid'">
          <app-product-grid
            class="product-toolbar-grid"
            [items]="filteredProducts"
          ></app-product-grid>
        </ng-container>
      </ng-container>
      <div class="text-center" *ngIf="lazyLoading">
        <p-progressSpinner mode="indeterminate"></p-progressSpinner>
      </div>
    </div>
    <!-- Modo Normal: Detalles en el bottom panel -->
    <div
      id="detailsContainer"
      class="product-details-container flex flex-column"
      *ngIf="showItemDetails && !showFloatingDetails"
      #detailsContainer
    >
      <div class="button-details-container flex-shrink-0">
        <div class="flex justify-content-end align-items-center w-full">
          <button class="detail-ctrl-btn" *ngIf="counterClickUp < 2" (click)="resizeDiv('up')">
            <i class="pi pi-angle-up"></i>
          </button>
          <button class="detail-ctrl-btn" *ngIf="counterClickDown < 2" (click)="resizeDiv('down')">
            <i class="pi pi-angle-down"></i>
          </button>
          <button class="detail-ctrl-btn detail-ctrl-btn--close" (click)="closeDetails()">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
      <app-product-details
        class="flex-grow-1 overflow-y-auto"
        [catalog]="catalog"
      ></app-product-details>
    </div>
  </div>

  <!-- Modo Flotante: Ventana flotante fija en inferior derecha -->
  <div
    class="floating-details-window"
    *ngIf="showItemDetails && showFloatingDetails"
  >
    <div class="floating-header">
      <div class="flex justify-content-between align-items-center w-full">
        <i
          class="pi pi-times counterButton"
          (click)="closeDetails()"
        ></i>
      </div>
    </div>
    <div class="floating-content">
      <app-product-details
        [catalog]="catalog"
      ></app-product-details>
    </div>
  </div>
</div>
